import { createSlice } from '@reduxjs/toolkit';

const initialStateValue = { data: '', record: '', showDeleteBtn: false, title: '' };

export const listOrdersSlice = createSlice({
  name: 'setOrderList',
  initialState: { value: initialStateValue },
  reducers: {
    setOrderList: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
    removeOrderList: (state) => {
      state.value = initialStateValue;
    },
  },
});

export const { setOrderList, removeOrderList } = listOrdersSlice.actions;

export default listOrdersSlice.reducer;
